'use strict';

import template from './alert.html';

const saAlert = function () {
  return {
    template: template,
    replace: true,
    scope: {
      accept: '&',
      decline: '&',
      options: '='
    },
    bindToController: true,
    controllerAs: 'ctrl',
    controller: [
      '$state', '$scope', 'report',

      function ($state, $scope, report) {
        $scope.$watch('ctrl.reportMessage', function() {
          report.reportMessage = $scope.ctrl.reportMessage;
        });

        this.buttonClicked = function(action, redirectTo) {

          switch (action) {
          case 'accept':
            this.accept();
            break;

          case 'decline':
            this.decline();
            break;
          }

          if (redirectTo) {
            $state.go(redirectTo);
          }
        };
      }
    ]
  };
};

export default saAlert;



// WEBPACK FOOTER //
// ./app/src/directives/alert.js